import { VpCloseIcon } from '@vtmn-play/icons/react'
import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import './family-chip.scss'

export interface FamilyChipProps {
  label: string
  remove: () => void
  id?: number
  color?: string
}

export function FamilyChip({
  label,
  remove,
  id,
  color = '',
}: Readonly<FamilyChipProps>) {
  const { t } = useTranslation()

  return (
    <VpButton
      size="small"
      className={`family-chip ${color}`}
      data-testid="family-chip"
      aria-label={t('aria-label.remove-family', { family: label })}
      onClick={remove}
    >
      {id && (
        <span className="family-chip-id" data-testid="family-chip-id">
          {`${id} - `}
        </span>
      )}
      <span className="family-chip-label">{label}</span>
      <VpCloseIcon data-testid="chip-remove-family" />
    </VpButton>
  )
}
